import { render, staticRenderFns } from "./addSignName.vue?vue&type=template&id=b5f9741a&scoped=true"
import script from "./addSignName.vue?vue&type=script&lang=js"
export * from "./addSignName.vue?vue&type=script&lang=js"
import style0 from "./addSignName.vue?vue&type=style&index=0&id=b5f9741a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f9741a",
  null
  
)

export default component.exports